import { DispatcherEvent } from '@carvana/merch-native';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import {
  getUserProfile,
  getUserPurchasing
} from '@/vdp/VehicleDetailsContainer/actions';
import OrderState from '~/constants/orderState';
import type { DispatchResult, Purchasing, User } from '~/contracts/vdp';
import { type PurchaseEventPayload } from '~/native/common/contracts';
import { getIsLoggedIn } from '~/selectors';
import { closeAccountModal, openAccountModal } from '~/utilities/accountModal';

type AppDispatch = ThunkDispatch<{}, any, AnyAction>;

type OnContinue = () => void;

function useLogInAndStartPurchase(eventPayload: PurchaseEventPayload) {
  const dispatch = useDispatch<AppDispatch>();
  const isLoggedIn = useSelector(getIsLoggedIn);

  return useCallback(
    (confirmContinue: OnContinue, onContinue: OnContinue) => () => {
      if (isLoggedIn) return onContinue();

      openAccountModal({
        callerIdentifier: 'StartPurchase',
        nativeOptions: {
          eventPayload,
          eventDispatch: DispatcherEvent.StartPurchase,
          eventSource: 'vdp'
        },
        onSuccess: async () => {
          await dispatch<DispatchResult<User>>(
            getUserProfile(new AbortController())
          );
          const purchaseResult = await dispatch<
            DispatchResult<Purchasing | null>
          >(getUserPurchasing());

          closeAccountModal();

          if (
            purchaseResult.action.payload?.orderState === OrderState.Reserved
          ) {
            confirmContinue();
          } else {
            onContinue();
          }
        }
      });
    },
    [dispatch, eventPayload, isLoggedIn]
  );
}

export default useLogInAndStartPurchase;
